import { render } from "./InsertLocation.vue?vue&type=template&id=ae462780&scoped=true"
import script from "./InsertLocation.vue?vue&type=script&lang=js"
export * from "./InsertLocation.vue?vue&type=script&lang=js"

import "./InsertLocation.vue?vue&type=style&index=0&id=ae462780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae462780"]])

export default __exports__